(function () {
  if (window.__pvsOversizeModal) { window.__pvsOversizeModal.refresh(); return; }

  // Two notices share this modal, so a cart holding both only asks once:
  //   oversized  - excluded from free delivery, ships at a calculated rate.
  //                Detection mirrors free-shipping-bar.js (Weather Shield / Flares
  //                types + the bulky floor-tile handles).
  //   made-to-order - built to order and dispatched on the date shown on the cart page.
  //                Driven by the 'preorder' tag, which /cart.js does not expose, so each
  //                cart handle is confirmed against /products/<handle>.js (that endpoint
  //                does carry tags).
  //   dispatch-hold - stock sitting at our own warehouse rather than the 3PL, so it cannot
  //                leave until that warehouse is staffed again. Driven by the
  //                'dispatch-hold' tag. Its WORDING is the product's
  //                custom.preorder_dispatch metafield, which no storefront JSON endpoint
  //                exposes, so Liquid hands it over in data-pvs-hold and this file never
  //                hand-types a date.
  var TILE_HANDLES = ['black-border-edge-corner', 'black-border-ramp-female',
    'black-border-ramp-male', 'double-garage-floor-kit-6x6m-single-colour',
    'garage-floor-tiles', 'thorburns-deco-flooring-6-wheeler', 'thorburns-deco-flooring'];

  // handle -> label ('' = made to order, label not resolved yet; false = not made to order).
  // Accumulated across the session; presence in the cart is decided by cart.js, which is
  // always current, so a handle lingering here cannot raise a false warning.
  var MTO = {};

  // handle -> dispatch wording ('' = held but wording not resolved yet; false = not held).
  // Same accumulate-and-let-cart.js-decide contract as MTO above.
  var HOLD = {};

  // Handles whose dispatch-hold state we have settled. Either the product endpoint confirmed the
  // tag, or Liquid told us this cart's LINE is not held; both stop resolve() re-flagging it.
  // Declared here because the first-paint hints below write to it before resolve() ever runs.
  var HOLD_CHECKED = {};

  // handle -> true when the product carries the 'no-production-notice' opt-out tag (2026-09-29).
  // Such a product keeps its 'preorder' tag (batch counter, cancellation row) but is not warned
  // about, and a dispatch-hold add-on sharing its _bundle_id line property is not warned about
  // either, because a bundled add-on ships with the unit. Oversized is never silenced.
  var QUIET = {};

  // variant id -> true when that cart LINE ships from stock (2026-09-30, Jamie: decide per
  // option, not per product). Liquid sets data-pvs-ship from the variant metafield
  // custom.in_stock_ship (crons/preorder_stock_sync.py, per-location stock at SKU Logistics,
  // CAV or PVS China) AND the live pvs-in-stock test. No storefront JSON endpoint exposes a
  // metafield, so Liquid is the only source. Rebuilt FRESH on every scan, never accumulated,
  // so a variant that sells out mid-session warns again; a variant Liquid has not seen yet
  // (added without a re-render) is not in the list and still warns.
  var SHIP = {};

  var state = { oversized: false, mto: false, hold: false, ack: false, labels: [],
    mtoLabels: [], mtoCount: 0, holdCount: 0, holdWhens: [] };
  var overlay = null, headEl = null, msgEl = null, subEl = null, pendingBtn = null;

  // Liquid's first-paint hint: handles it saw tagged 'preorder' in the cart. Labels are
  // resolved lazily below, so an unresolved handle still warns (with generic wording)
  // rather than staying silent.
  function readMtoHint() {
    var els = document.querySelectorAll('[data-pvs-mto]');
    for (var i = 0; i < els.length; i++) {
      var handles = (els[i].getAttribute('data-pvs-mto') || '').split(',');
      for (var j = 0; j < handles.length; j++) {
        var h = handles[j].trim();
        if (h && MTO[h] === undefined) MTO[h] = '';
      }
    }
  }

  // Liquid's dispatch-hold hint: "handle::wording||handle::wording||". The wording half is
  // the only source of the date, so a later empty hint must not wipe a wording we already
  // hold (a section re-render can arrive before its metafield does).
  function readHoldHint() {
    var els = document.querySelectorAll('[data-pvs-hold]');
    for (var i = 0; i < els.length; i++) {
      var rows = (els[i].getAttribute('data-pvs-hold') || '').split('||');
      for (var j = 0; j < rows.length; j++) {
        var row = rows[j].trim();
        if (!row) continue;
        var cut = row.indexOf('::');
        var h = (cut < 0 ? row : row.slice(0, cut)).trim();
        var when = cut < 0 ? '' : row.slice(cut + 2).trim();
        if (!h) continue;
        if (when) HOLD[h] = when;
        else if (HOLD[h] === undefined) HOLD[h] = '';
      }
    }
  }

  // ⭐⭐ 2026-09-08: a cart LINE is a variant and the hold is per variant, so Liquid also tells us
  // which handles are present but NOT held. Without it resolve() would look the handle up, see the
  // product tag, and warn about a variant the 3PL ships tomorrow. Read BEFORE readHoldHint so a
  // cart holding a held and an unheld variant of the same product still warns.
  function readHoldFree() {
    var els = document.querySelectorAll('[data-pvs-hold-free]');
    for (var i = 0; i < els.length; i++) {
      var handles = (els[i].getAttribute('data-pvs-hold-free') || '').split(',');
      for (var j = 0; j < handles.length; j++) {
        var h = handles[j].trim();
        if (!h) continue;
        HOLD[h] = false;
        HOLD_CHECKED[h] = true;
      }
    }
  }

  // Liquid's opt-out hint: handles in the cart tagged 'no-production-notice'.
  function readQuietHint() {
    var els = document.querySelectorAll('[data-pvs-quiet]');
    for (var i = 0; i < els.length; i++) {
      var handles = (els[i].getAttribute('data-pvs-quiet') || '').split(',');
      for (var j = 0; j < handles.length; j++) {
        var h = handles[j].trim();
        if (!h) continue;
        QUIET[h] = true;
        MTO[h] = false;
      }
    }
  }

  function readShipHint() {
    SHIP = {};
    var els = document.querySelectorAll('[data-pvs-ship]');
    for (var i = 0; i < els.length; i++) {
      var ids = (els[i].getAttribute('data-pvs-ship') || '').split(',');
      for (var j = 0; j < ids.length; j++) {
        var id = ids[j].trim();
        if (id) SHIP[id] = true;
      }
    }
  }

  // Initial state from the Liquid-rendered flags, so the very first checkout
  // click is correct before the /cart.js fetch resolves.
  readMtoHint();
  readQuietHint();
  readShipHint();
  readHoldFree();
  readHoldHint();
  var initEl = document.querySelector('[data-pvs-oversized-init]');
  if (initEl) state.oversized = initEl.getAttribute('data-pvs-oversized-init') === '1';
  for (var k in MTO) { if (MTO[k] !== false) { state.mto = true; break; } }
  for (var kh in HOLD) { if (HOLD[kh] !== false) { state.hold = true; break; } }

  function uniquePush(arr, val) { if (val && arr.indexOf(val) < 0) arr.push(val); }

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  // Option text worth showing. 2026-09-30: drop placeholder segments ("Default Title", empty,
  // or a bracketed value like "(Included Free)") so the Y61 headunit is not named
  // "((Included Free) / (Included Free))". Real options ("Front + Rear / Grey") pass through.
  function optionLabel(v) {
    if (!v || v === 'Default Title') return '';
    var keep = [];
    var segs = String(v).split(' / ');
    for (var i = 0; i < segs.length; i++) {
      var s = segs[i].trim();
      if (!s || s === 'Default Title' || /^\(.*\)$/.test(s)) continue;
      keep.push(s);
    }
    return keep.join(' / ');
  }

  // "Product (Option)" for one cart line, so a mixed cart names only the lines in production.
  function lineName(item) {
    var n = item.product_title || item.title || '';
    var v = optionLabel(item.variant_title);
    if (v) n += ' (' + v + ')';
    return n;
  }

  // Name the notice after the product type, pluralised. Types that are already plural pass
  // through; mass nouns take " items" so we never print "Storages" or "Gears".
  function labelFor(type) {
    if (!type) return '';
    if (/s$/.test(type)) return type;
    if (type === 'Storage' || type === 'Gear') return type + ' items';
    return type + 's';
  }

  // Confirm handles we have not classified yet. /products/<handle>.js carries tags + type,
  // which /cart.js does not, so this is what makes the gate independent of a drawer re-render.
  function resolve(handles) {
    var pending = [];
    for (var i = 0; i < handles.length; i++) {
      var h0 = handles[i];
      if (MTO[h0] === undefined || MTO[h0] === '' || HOLD_CHECKED[h0] === undefined) {
        uniquePush(pending, h0);
      }
    }
    if (!pending.length) return Promise.resolve(false);
    return Promise.all(pending.map(function (h) {
      return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) return;
          var isQuiet = !!(p.tags && p.tags.indexOf('no-production-notice') >= 0);
          if (isQuiet) QUIET[h] = true;
          var isMto = !isQuiet && p.tags && p.tags.indexOf('preorder') >= 0;
          // Always store a non-empty label for a hit, so an untyped product resolves once
          // instead of looking unresolved and refetching on every refresh.
          MTO[h] = isMto ? (labelFor(p.type) || 'made-to-order items') : false;
          // The tag is the switch, so this endpoint settles it. The wording is a metafield
          // and cannot come from here, so a confirmed hold with no wording yet stays ''
          // (it still warns, with generic words) rather than being dropped.
          HOLD_CHECKED[h] = true;
          if (p.tags && p.tags.indexOf('dispatch-hold') >= 0) {
            if (!HOLD[h]) HOLD[h] = '';
          } else {
            HOLD[h] = false;
          }
        })
        // Leave an unresolved handle as-is: a Liquid-hinted one stays flagged with generic
        // wording, an unknown one is retried on the next refresh.
        .catch(function () {});
    })).then(function () { return true; });
  }

  function scan(cart) {
    readMtoHint();
    readQuietHint();
    readShipHint();
    readHoldFree();
    readHoldHint();
    // Bundles anchored by an opted-out product: their held add-ons ship with the unit.
    var quietBundles = {};
    if (cart && cart.items) {
      for (var qi = 0; qi < cart.items.length; qi++) {
        var qItem = cart.items[qi];
        var qId = qItem.properties && qItem.properties._bundle_id;
        if (qId && QUIET[qItem.handle]) quietBundles[qId] = true;
      }
    }
    var ws = false, flare = false, tile = false, mtoLabels = [], mto = false, mtoCount = 0;
    var mtoNames = [];
    var hold = false, holdCount = 0, holdWhens = [], lineCount = 0;
    if (cart && cart.items) {
      lineCount = cart.items.length;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (item.product_type === 'Weather Shield') { ws = true; }
        if (item.product_type === 'Flares') { flare = true; }
        if (TILE_HANDLES.indexOf(item.handle) >= 0) { tile = true; }
        if (MTO[item.handle] !== undefined && MTO[item.handle] !== false &&
            !SHIP[String(item.variant_id)]) {
          mto = true;
          mtoCount += item.quantity;
          uniquePush(mtoLabels, MTO[item.handle]);
          uniquePush(mtoNames, lineName(item));
        }
        var bId = item.properties && item.properties._bundle_id;
        var bundledQuiet = !!(bId && quietBundles[bId]);
        if (!bundledQuiet && HOLD[item.handle] !== undefined && HOLD[item.handle] !== false) {
          hold = true;
          holdCount += 1;
          uniquePush(holdWhens, HOLD[item.handle]);
        }
      }
    }
    state.hold = hold;
    state.holdCount = holdCount;
    state.holdWhens = holdWhens;
    state.holdOther = lineCount - holdCount;
    state.oversized = ws || flare || tile;
    var parts = [];
    if (ws) parts.push('Weather Shields');
    if (flare) parts.push('Fender Flares');
    if (tile) parts.push('Floor Tiles');
    state.labels = parts;
    state.mtoLabels = mtoLabels;
    state.mtoNames = mtoNames;
    state.mtoCount = mtoCount;
    state.mto = mto;
    // If the flagged items were removed, clear the acknowledgement so a later
    // re-add warns again.
    if (!state.oversized && !state.mto && !state.hold) state.ack = false;
  }

  function joinLabels(parts, fallback) {
    if (!parts.length) return fallback;
    if (parts.length === 1) return parts[0];
    return parts.slice(0, -1).join(', ') + ' &amp; ' + parts[parts.length - 1];
  }

  function injectStyle() {
    if (document.getElementById('pvs-ovm-style')) return;
    var s = document.createElement('style');
    s.id = 'pvs-ovm-style';
    s.textContent = [
      '.pvs-ovm{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;font-family:inherit;}',
      '.pvs-ovm[hidden]{display:none;}',
      '.pvs-ovm__scrim{position:absolute;inset:0;background:rgba(17,17,17,.55);backdrop-filter:saturate(120%) blur(2px);animation:pvsOvmFade .18s ease;}',
      '.pvs-ovm__box{position:relative;max-width:420px;width:100%;background:#fff;color:#111;border-radius:16px;padding:26px 24px 22px;box-shadow:0 24px 60px rgba(0,0,0,.28);text-align:left;animation:pvsOvmPop .22s cubic-bezier(.34,1.56,.64,1);}',
      '.pvs-ovm__ico{width:40px;height:40px;color:#c8811a;margin:0 0 12px;}',
      '.pvs-ovm__box h2{margin:0 0 8px;font-size:20px;line-height:1.25;font-weight:800;letter-spacing:-.02em;}',
      '.pvs-ovm__msg{margin:0 0 6px;font-size:15px;line-height:1.5;color:#2a2a2a;}',
      '.pvs-ovm__msg b{font-weight:700;}',
      '.pvs-ovm__msg ul{margin:0;padding:0;list-style:none;}',
      '.pvs-ovm__msg li{position:relative;padding:0 0 0 16px;margin:0 0 8px;}',
      '.pvs-ovm__msg li:last-child{margin-bottom:0;}',
      '.pvs-ovm__msg li:before{content:"";position:absolute;left:2px;top:9px;width:5px;height:5px;border-radius:50%;background:#c8811a;}',
      '.pvs-ovm__sub{margin:14px 0 20px;font-size:13.5px;line-height:1.5;color:#5a5a5a;}',
      '.pvs-ovm__actions{display:flex;gap:10px;flex-wrap:wrap;}',
      '.pvs-ovm__actions button{flex:1 1 auto;min-width:130px;border-radius:999px;padding:12px 16px;font-size:15px;font-weight:700;cursor:pointer;border:1px solid transparent;font-family:inherit;transition:transform .08s ease,background .15s ease;}',
      '.pvs-ovm__actions button:active{transform:scale(.98);}',
      '.pvs-ovm__back{background:#f2f2f4;color:#111;}',
      '.pvs-ovm__back:hover{background:#e8e8ea;}',
      '.pvs-ovm__go{background:#0071e3;color:#fff;}',
      '.pvs-ovm__go:hover{background:#0063c7;}',
      'html.pvs-ovm-lock,body.pvs-ovm-lock{overflow:hidden;}',
      '@keyframes pvsOvmFade{from{opacity:0}to{opacity:1}}',
      '@keyframes pvsOvmPop{from{opacity:0;transform:translateY(8px) scale(.98)}to{opacity:1;transform:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function buildModal() {
    if (overlay) return;
    injectStyle();
    overlay = document.createElement('div');
    overlay.className = 'pvs-ovm';
    overlay.setAttribute('hidden', '');
    overlay.innerHTML =
      '<div class="pvs-ovm__scrim" data-close></div>' +
      '<div class="pvs-ovm__box" role="dialog" aria-modal="true" aria-labelledby="pvs-ovm-h">' +
        '<svg class="pvs-ovm__ico" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M12 3.5 1.8 21h20.4L12 3.5Z"/><path d="M12 10v5"/><circle cx="12" cy="18" r=".6" fill="currentColor" stroke="none"/></svg>' +
        '<h2 id="pvs-ovm-h">Before you check out</h2>' +
        '<div class="pvs-ovm__msg"></div>' +
        '<p class="pvs-ovm__sub"></p>' +
        '<div class="pvs-ovm__actions">' +
          '<button type="button" class="pvs-ovm__back" data-close>Back to cart</button>' +
          '<button type="button" class="pvs-ovm__go">Continue to checkout</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(overlay);
    headEl = overlay.querySelector('#pvs-ovm-h');
    msgEl = overlay.querySelector('.pvs-ovm__msg');
    subEl = overlay.querySelector('.pvs-ovm__sub');

    overlay.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-close')) close();
    });
    overlay.querySelector('.pvs-ovm__go').addEventListener('click', proceed);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && !overlay.hasAttribute('hidden')) close();
    });
  }

  function oversizedNotice() {
    var name = joinLabels(state.labels, 'an oversized item');
    var isPlural = state.labels.length !== 1 || /s$/.test(name);
    return 'Your cart contains <b>' + name + '</b>, ' +
      (isPlural ? 'which are oversized items' : 'which is an oversized item') +
      '. Shipping is calculated at checkout and free delivery doesn\'t apply to ' +
      (isPlural ? 'them' : 'it') + '.';
  }

  function mtoNotice() {
    var names = state.mtoNames || [];
    if (names.length && names.length <= 3) {
      var list = names.map(function (n) { return '<b>' + esc(n) + '</b>'; });
      var joined = list.length === 1 ? list[0]
        : list.slice(0, -1).join(', ') + ' and ' + list[list.length - 1];
      return 'Your cart contains ' + joined + (list.length === 1 ? ', which is' : ', which are') +
        ' in production. The dispatch date is shown on the cart page.';
    }
    var plural = state.mtoCount !== 1;
    return 'Your cart contains ' + (plural ? '<b>items</b> that are' : '<b>an item</b> that is') +
      ' in production. The dispatch date is shown on the cart page.';
  }

  // The words come from the product's custom.preorder_dispatch metafield via Liquid. If that
  // has not arrived yet we still warn, just without a date, because a silent gate is worse
  // than a vague one.
  // The wording is merchant-set text going into innerHTML, so escape it, and drop any
  // trailing full stop so we do not print "November 2026..".
  function tidyWhen(w) {
    return String(w).replace(/[.\s]+$/, '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function holdNotice() {
    var plural = state.holdCount !== 1;
    var subject = plural ? 'items that are' : 'an item that is';
    var whens = state.holdWhens.filter(function (w) { return !!w; }).map(tidyWhen);
    if (whens.length === 1) {
      return 'Your cart contains ' + subject + ' not dispatched yet. <b>' + whens[0] + '.</b>';
    }
    if (whens.length > 1) {
      return 'Your cart contains ' + subject + ' not dispatched yet. <b>' +
        whens.join('. ') + '.</b>';
    }
    return 'Your cart contains ' + subject + ' not dispatched yet. ' +
      (plural ? 'They leave' : 'It leaves') + ' later than the rest of your order.';
  }

  function render() {
    var notices = [];
    if (state.oversized) notices.push(oversizedNotice());
    if (state.mto) notices.push(mtoNotice());
    if (state.hold) notices.push(holdNotice());

    if (state.hold && !state.oversized && !state.mto) headEl.textContent = 'Dispatching later';
    else if (state.mto && !state.oversized && !state.hold) headEl.textContent = 'In production';
    else headEl.textContent = 'Before you check out';

    msgEl.innerHTML = notices.length > 1
      ? '<ul><li>' + notices.join('</li><li>') + '</li></ul>'
      : '<p style="margin:0">' + (notices[0] || '') + '</p>';

    var subs = [];
    if (state.oversized) subs.push('Your other items are unaffected. The exact shipping cost is shown at the payment step before you pay.');
    // Only worth saying when there IS something else in the cart to be dispatched.
    if (state.hold && !state.oversized && state.holdOther > 0) {
      subs.push('Your other items dispatch on their own timing.');
    }
    subEl.textContent = subs.join(' ');
  }

  function open() {
    buildModal();
    render();
    overlay.removeAttribute('hidden');
    document.documentElement.classList.add('pvs-ovm-lock');
    document.body.classList.add('pvs-ovm-lock');
    var go = overlay.querySelector('.pvs-ovm__go');
    if (go) go.focus();
  }

  function close() {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.documentElement.classList.remove('pvs-ovm-lock');
    document.body.classList.remove('pvs-ovm-lock');
    pendingBtn = null;
  }

  function proceed() {
    state.ack = true;
    var btn = pendingBtn;
    close();
    // Re-fire the original checkout click; state.ack is now true so the
    // interceptor lets it through and the form submits normally (preserving
    // the button's name="checkout").
    if (btn) setTimeout(function () { btn.click(); }, 0);
  }

  // Intercept the checkout button (cart page + drawer) in the capture phase so
  // we can cancel the submit before the theme handles it.
  // 25 Oct 2026 (owner approved the buyer walkthrough fixes): a made-to-order line on its own
  // never stops checkout. Its lead time already shows inline on the cart row (pvs-dispatch-badge),
  // and the blocking "In production" warning was where 84% of wheel kit carts stopped. Only an
  // oversized item or a dispatch hold still asks for an acknowledgement; when one does, the
  // made-to-order line is listed inside that same notice.
  document.addEventListener('click', function (e) {
    if ((!state.oversized && !state.hold) || state.ack) return;
    var btn = e.target.closest ? e.target.closest('[name="checkout"]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    pendingBtn = btn;
    open();
  }, true);

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        scan(cart);
        var handles = (cart.items || []).map(function (i) { return i.handle; });
        // Re-scan once the lookups land, so labels (and any handle Liquid missed) are
        // reflected. If the modal is already open on screen, repaint it in place.
        return resolve(handles).then(function (changed) {
          if (!changed) return;
          scan(cart);
          if (overlay && !overlay.hasAttribute('hidden')) render();
        });
      })
      .catch(function () {});
  }

  window.__pvsOversizeModal = { refresh: refresh };

  refresh();

  ['on:cart:add', 'on:line-item:change', 'dispatch:cart-drawer:refresh', 'cart:updated', 'cart:refresh']
    .forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(refresh, 60); });
    });
})();
